import { WebhookSubscription } from '../models/webhookSubscriptions';
import ApiService from './apiService';

class WebhookSubscriptionService extends ApiService {
  private static instance?: WebhookSubscriptionService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!WebhookSubscriptionService.instance) {
      WebhookSubscriptionService.instance = new WebhookSubscriptionService();
    }
    return WebhookSubscriptionService.instance;
  }

  getAll(): Promise<WebhookSubscription[]> {
    return this.client.get(`/configuration/webhook-subscriptions`).then((response) => response.data);
  }

  getById(id: string): Promise<WebhookSubscription> {
    return this.client.get(`/configuration/webhook-subscriptions/${id}`).then((response) => response.data);
  }

  create(subscription: WebhookSubscription): Promise<WebhookSubscription> {
    return this.client.post(`/configuration/webhook-subscriptions`, subscription).then((response) => response.data);
  }

  update(id: string, subscription: WebhookSubscription): Promise<WebhookSubscription> {
    return this.client
      .put(`/configuration/webhook-subscriptions/${id}`, subscription)
      .then((response) => response.data);
  }

  delete(id: string): Promise<void> {
    return this.client.delete(`/configuration/webhook-subscriptions/${id}`);
  }
}

export default WebhookSubscriptionService;
